export const STORAGE_KEYS = {
    MEALS_STORAGE: "meals_storage",
    KITCHEN_MEALS_STORAGE: "kitchen_meals_storage",
    MEALS_ORDERING_STORAGE: "meals_ordering_storage",
    APP_SETTINGS: "app_settings",
};
